
import { Component, Vue } from 'vue-property-decorator';
import { getOnlineNumber } from '@/api/statistics';
import { getTimeSlot } from '@/utils/common';
@Component
export default class extends Vue {
  dates: (string | Date)[] = [];
  onlineTable = [];
  loading: boolean = false;
  total: number = 0;
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  deviceParams = {
    start: 0,
    end: 0,
    page: 1,
    page_size: 10,
  };
  dateHandler(datavalue: Date[]) {
    this.deviceParams.start = Math.floor(datavalue[0].getTime() / 1000);
    this.deviceParams.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.deviceParams.page = 1;
    this.getDeviceOnline();
  }
  handleSizeChange(page_size: number) {
    this.deviceParams.page = 1;
    this.deviceParams.page_size = page_size;
    this.getDeviceOnline();
  }
  handleCurrentChange(page: number) {
    this.deviceParams.page = page;
    this.getDeviceOnline();
  }
  async getDeviceOnline() {
    this.loading = true;
    try {
      const res = await getOnlineNumber(this.deviceParams);
      if (res && res.code == 0) {
        this.onlineTable = res.data.list;
        this.total = res.data.total;
      }
      this.loading = false;
    } catch (err) {
      //
      this.loading = false;
    }
  }
  mounted() {
    this.$nextTick(() => {
      let { dataValue, params } = getTimeSlot(7); // 最近7天
      this.deviceParams.start = params.start;
      this.deviceParams.end = params.end;
      this.dates = dataValue;
      this.getDeviceOnline();
    });
  }
}
